// 表单项渲染字段 统一数据结构 其它扩展字段放置extraProps
export function getDocumentField(props) {
  return {
    key: props.key,
    name: props.name,
    fieldType: props.fieldType,
    placeholder: props.placeholder,
    value: getVal(props, 'value', ''),
    show: getVal(props, 'show', true),
    showValue: getVal(props, 'showValue', ''),
    handleClick: getVal(props, 'handleClick', ''),
    editable: getVal(props, 'editable', true),
    required: getVal(props, 'required', false),
    maxLength: props.maxLength,
    extraProps: props.extraProps || {},
  };
}

// 接收到参数就取参数值
function getVal(obj, key, defaultValue) {
  return obj.hasOwnProperty(key) ? obj[key] : defaultValue;
}
